
export type AlertFilterType = 'all' | 'email' | 'api' | 'sms';

export const ALL_ALERTS: AlertFilterType = 'all';

/** Display labels for each channel filter option. */
export const ALERT_CHANNEL_LABELS: Record<AlertFilterType, string> = {
  all: 'All Alerts',
  email: 'Email',
  api: 'API',
  sms: 'SMS',
};

export const ALERT_CHANNELS: AlertFilterType[] = ['email', 'api', 'sms'];
